/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// TODO: replace plugin tailwind/forms that makes imposible
// to style a real checkbox with our design system
export const Checkbox = ({
  checked = false,
  className = '',
  interactive = false,
  disabled = false,
  onClick = () => null
}) => (
  <div
    onClick={() => onClick()}
    className={`bg-white grid place-content-center m-0 text-current w-6 h-6 border border-gray-500 rounded-full transition-all duration-300 before:grid before:content-[''] before:w-6 before:h-6 before:rounded-full before:scale-0 before:transition-all before:duration-150 before:ease-in-out before:bg-no-repeat before:bg-green-800/20 before:bg-center before:bg-tick ${
      !!checked && 'before:scale-100 ring-1 ring-green-800 border-green-800'
    } ${interactive && 'cursor-pointer'} ${
      disabled && '!bg-gray-300'
    } ${className}`}
  />
)

export const CheckboxInput = ({ children, handleCheck, id }) => (
  <label
    className='appearance-none flex items-center flex-nowrap text-purple-900 font-medium text-base mt-4 mb-6 align-center'
    htmlFor={id}
  >
    <input
      className='appearance-none checkbox-custom cursor-pointer'
      id={id}
      name='checkbox-checked'
      type='checkbox'
      onClick={handleCheck}
    />
    <span className='ml-2'>{children}</span>
  </label>
)
